<template>
  <div class="login">
    <img class="logo" src="./logo.png" alt="" />
    <h1>特省惠APP</h1>
    <div
      v-if="!isWeChat"
      @click="handleDownload"
      class="delivery-btn"
      :data-clipboard-text="extinfo"
    >
      <div class="weixin">
        <div>打开特省惠</div>
      </div>
    </div>

    <div v-else>
      <wx-open-launch-app
        appid="wx4368136db77ac508"
        :extinfo="extinfo"
        @launch="openLaunch"
        @error="openError"
      >
        <script type="text/wxtag-template">
          <style>
          	.btn {
          		width:260px;
          		height:50px;
          		line-height: 50px;
          		font-size: 18px;
          		border:none;
          		color:#fff;
          		border-radius: 50px;
              background: #FC8732;
          		//background-image: linear-gradient(to right, #151313 , #a19f9f);
          	}
          </style>
          <button class="btn">打开特省惠</button>
        </script>
      </wx-open-launch-app>
    </div>
    <!-- 底部归属 -->
    <div class="bottom">
      <div class="">Copyright©2023</div>
      <div class="" @click="handleTest">{{ appName }} 版权所有</div>
    </div>
  </div>
</template>

<script>
import AJAX from "@/utils/AJAX.js";
import Clipboard from "clipboard";
export default {
  name: "Home",
  data() {
    return {
      appName: "福建望月云文化传媒有限公司",
      isWeChat: true,
      isIos: false,
      inviteCode: "",
      actConfigId: "",
      departId: "",
      actType: "",
      activityId: "",
      activityType: "",
      taskId: "",
      type: "",
      extinfo: "",
    };
  },
  created() {
    //https://tsh.wangyyapp.com?inviteCode=997869&activityId=1626523509658247169&activityType=16
    let that = this;
    this.isWeChatHandler();
    this.extinfo = "";
    this.inviteCode = this.getQueryVariable("inviteCode");
    this.actConfigId = this.getQueryVariable("actConfigId");
    this.departId = this.getQueryVariable("departId");
    this.actType = this.getQueryVariable("actType");
    this.activityId = this.getQueryVariable("activityId");
    this.activityType = this.getQueryVariable("activityType");
    this.taskId = this.getQueryVariable("taskId");
    this.type = this.getQueryVariable("type");
    if (this.inviteCode) {
      this.extinfo = this.extinfo + "inviteCode=" + this.inviteCode;
    }
    if (this.departId) {
      this.extinfo = this.extinfo + "departId=" + this.departId;
    }
    if (this.actConfigId) {
      this.extinfo = this.extinfo + "&actConfigId=" + this.actConfigId;
    }
    if (this.actType) {
      this.extinfo = this.extinfo + "&actType=" + this.actType;
    }
    if (this.activityId) {
      this.extinfo = this.extinfo + "&activityId=" + this.activityId;
    }
    if (this.activityType) {
      this.extinfo = this.extinfo + "&activityType=" + this.activityType;
    }


    if (this.taskId) {
      this.extinfo = this.extinfo + "&taskId=" + this.taskId;
    }
    if (this.type) {
      this.extinfo = this.extinfo + "&type=" + this.type;
    }
    this.extinfo = this.extinfo + "&share=true";
    ShareTrace.init({
      appkey: "1aa3334e867a787f", // 此值必填
      param: that.extinfo,
      success: function () {
        console.log("init success...");
      },
      error: function (msg) {
        console.log(msg);
      },
    });
  },
  mounted() {},
  methods: {
    getQueryVariable(name) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = window.location.search.split("?")[1];
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj[name];
    },
    isWeChatHandler() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) &&
        ua.match(/MicroMessenger/i)[0] === "micromessenger" &&
        ua.match(/Android/i)
      ) {
        console.log("微信登录");
        this.isWeChat = true;
        this.JsSdkSign();
      } else {
        console.log("非微信登录");
        this.isWeChat = false;
      }
      if (!ua.match(/Android/i)) {
        this.isIos = true;
      }
    },
    // 微信sdk
    async JsSdkSign() {
      let that = this;
      let url = window.location.href;
      let params = {
        url: url,
      };
      console.log("params", params);
      // alert("微信sdk=url"+params)
      let res = await AJAX.JsSdkSign(params);
      alert(JSON.stringify(res));
      let data = res.result;
      console.log("JsSdkSign", res);
      window.wx.config({
        debug: true,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [],
        openTagList: ["wx-open-launch-app"],
        success: function (res) {
          alert(res);
          that.checkApi();
        },
        fail: function (res) {
          console.log(res)
          alert(res);
          // alert("配置jssdk， 失败！");
        },
      });
    },
    checkApi: function (res) {
      window.wx.checkJsApi({
        openTagList: ["wx-open-launch-app"],
        success: function (res) {
          debugger
          console.log("检查微信接口", res);
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        },
        fail: function (res) {
          debugger
          console.log(res)
          // alert("配置jssdk， 失败！");
        },
      });
    },
    handleDownload() {
      this.copy();
      // 请在用户点击下载按钮时，触发此函数
      ShareTrace.download();
    },
    // 把信息复制到粘贴板
    copy() {
      if (this.isIos) {
        let clipboard = new Clipboard(".delivery-btn");
        clipboard.on("success", function (e) {
          console.log("复制成功");
          e.clearSelection();
        });
        clipboard.on("error", function (e) {
          console.log("复制失败");
        });
      }
    },
    openLaunch(e) {
      console.log("打开成功", e);
    },

    openError(e) {
      ShareTrace.download();
      console.log("打开失败", e);
    },
    handleTest() {
      // window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent('https://m.tb.cn/h.i3VJKsV?visa=701e9209f542c59d')}`;
      // window.location.href = 'tbopen://market.m.taobao.com/app/tb-trade/help-pay/home.html?UUID=1773244803967&disableNav=YES&newAgent=1&open_from=scan_f2f&orderIds=%5B%224502111832156026608%22%5D&orderSignSecret=_ln_j_b_jnki_rp2g_m_p_x0_met_by_s_yx_ig_m_e_r%20_d4_t_p_y_ncz51_io5_w_ao%2F9_jh_k%2F_mw%3D%3D&payee=382323970&sourceType=other&suid=5576f92f-4de8-40fe-8a05-678a54a674e3&ut_sk=1.ZgwmkV3ROt0DADXh9WQHahPL_21646297_1773201185174.QRCode-Scan.bangwofu&un=005bc8c2fc73908a4c6e4bed9157ce66&share_crt_v=1&un_site=0&cpp=1&shareurl=true&spm=a313p.3141.6bmj2a.1947798591681&short_name=h.i3VJKsV&bxsign=scdzFPkObOvqDcc1jf57UXiejmxTdigrKQ3Oquf_e8NWwBUPvLuH3tuYPM_f4ATV_dnJ9uo_NIk_REXAi-ynMWsyWxnq8SzQP95TLRnRg96H0tZCv9N17BNYgiT7SsgBPfo'
      // window.location.href = 'tbopen://m.taobao.com/tbopen/index.html?h5Url=https%3A%2F%2Fmarket.m.taobao.com%2Fapp%2Ftb-trade%2Fhelp-pay%2Fhome.html%3FUUID%3D1773244803967%26disableNav%3DYES%26newAgent%3D1%26open_from%3Dscan_f2f%26orderIds%3D%255B%25224502111832156026608%2522%255D%26orderSignSecret%3D_ln_j_b_jnki_rp2g_m_p_x0_met_by_s_yx_ig_m_e_r%2520_d4_t_p_y_ncz51_io5_w_ao%252F9_jh_k%252F_mw%253D%253D%26payee%3D382323970%26sourceType%3Dother%26suid%3D5576f92f-4de8-40fe-8a05-678a54a674e3%26ut_sk%3D1.ZgwmkV3ROt0DADXh9WQHahPL_21646297_1773201185174.QRCode-Scan.bangwofu%26un%3D005bc8c2fc73908a4c6e4bed9157ce66%26share_crt_v%3D1%26un_site%3D0%26cpp%3D1%26shareurl%3Dtrue%26spm%3Da313p.3141.6bmj2a.1947798591681%26short_name%3Dh.i3VJKsV%26bxsign%3DscdzFPkObOvqDcc1jf57UXiejmxTdigrKQ3Oquf_e8NWwBUPvLuH3tuYPM_f4ATV_dnJ9uo_NIk_REXAi-ynMWsyWxnq8SzQP95TLRnRg96H0tZCv9N17BNYgiT7SsgBPfo&action=ali.open.nav&module=h5&bootImage=0&slk_sid=HK4hIh5Dq3UCAd7U3p3hzaSF_1773291443960&slk_t=1773291459294&afcPromotionOpen=false&bc_fl_src=h5_huanduan&source=slk_dp'
      // window.location.href = 'tbopen://m.taobao.com/tbopen/index.html?h5Url=https%3A%2F%2Fm.tb.cn%2Fh.i3VJKsV'

      // window.location.href = 'alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Fds.alipay.com%2F%3FappId%3D20000125%26orderSuffix%3Dapp_name%253D%2522alipay%2522%2526trade_no%253D%25222026031204200348481021696259%2522%2526bizcontext%253D%2522%257B%2522app%2522%253A%2522%2522%252C%2522channel%2522%253A%2522%2522%252C%2522domain%2522%253A%2522render.alipay.com%2522%252C%2522extInfo%2522%253A%257B%2522ap_link_token%2522%253A%2522%2522%257D%252C%2522isThirdDomain%2522%253Afalse%252C%2522sc%2522%253A%2522jsapi%2522%252C%2522useScan%2522%253A%2522camera%2522%257D%2522%2526biz_type%253D%2522share_pp_pay%2522%2526biz_sub_type%253D%2522peerpay_trade%2522%2526display_pay_result%253D%2522true%2522%2526appenv%253D%2522system%253Dandroid%255Eappid%253Dalipay%255Eversion%253D10.7.16.8000%2522'
      // const S = function() {
      //   for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32, t = "EP", n = 0; n < e; n++)
      //     t += "0123456789abcdefABCDEF_".charAt(Math.floor(23 * Math.random()));
      //   return t
      // }(32)
      // AlipayJSBridge.call('tradePay', {
      //   tradeNO: '2026031204200348481021696259',
      //   bizType: "share_pp_pay",
      //   bizSubType: "peerpay_trade",
      //   bizContext: JSON.stringify({
      //     app: "tb",
      //     channel: "qr_code",
      //     extInfo: {
      //       ap_link_token: S
      //     }
      //   })
      // }, async function(result) {
      //   if (result.resultCode === '9000') {
      //     alert('支付成功');
      //   } else {
      //     await alert('支付失败: ' + (result.memo || '未知错误'));
      //     AlipayJSBridge.call('closeWebview');
      //   }
      // });
    }
  },
};
</script>

<style>
.login {
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow: hidden;
   /*justify-content: center;
   margin-top: -10px;*/
}
.logo {
  margin-top: 5rem;
  width: 7rem;
  height: 7rem;
  border-radius: 1rem;
}
h1 {
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 4rem;
}
.bg {
  width: 30rem;
  height: 30rem;
}
h2 {
  width: 17.0625rem;
  height: 4.25rem;
}
.weixin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 17.0625rem;
  height: 4.25rem;
  line-height: 4.25rem;
}
.weixin div {
  width: 94%;
  line-height: 3.1rem;
  text-align: center;
  border-radius: 3rem;
  font-size: 20px;
  color: white;
  font-weight: bolder;
  background: #FC8732;
}
.bottom {
  margin-top: 9.375rem;
  text-align: center;
  font-size: 0.8125rem;
  color: #666666;
}
</style>
